import React, { useEffect } from "react";
import { observer } from "mobx-react";
import "primeflex/primeflex.css";
import { BookOfBusinessViewModel } from "./BookOfBusinessViewModel";
import { IMASMessagesHandler } from "../components/controls/IMASMessagesHandler";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import Utils from "../../infrastructure/Utils";
import { Permission } from "../../infrastructure/enum/Permission";
import "./BookOfBusiness.css";
import UserContext from "../../infrastructure/UserContext";
import { getToken } from "../../infrastructure/Auth0Authenticator";
import { respondToAuthCacheRequest } from "../../infrastructure/authCacheRelay";

// Split out of BookOfBusinessView because that component is wrapped in mobx's
// observer(), which mobx-react@5 renders as a class component under the hood -
// hooks cannot run inside a class component's render(), so the relay effect
// has to live in its own plain sibling component instead.
const BookOfBusinessAuthRelay: React.FC<{ bookBaseUrl: string }> = ({
  bookBaseUrl,
}) => {
  useEffect(() => {
    // Pre-warm the token getter now rather than lazily inside the responder -
    // it's serialized behind IMAS's own page-load API calls via a Web Lock,
    // so calling it here lets it settle before the child's REQUEST_AUTH_CACHE
    // (sent on a short timeout) arrives, closing the cold-load race.
    getToken().catch(() => {});

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== bookBaseUrl) return;

      respondToAuthCacheRequest(event, bookBaseUrl);

      if (event.data && event.data.type === "WARNING_TOAST") {
        Utils.showWarningToaster(event.data.message, 3000, 500);
      } else if (event.data && event.data.type === "SUCCESS_TOAST") {
        Utils.showSuccessToaster(event.data.message, 3000, 500);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [bookBaseUrl]);

  return null;
};

export const BookOfBusinessView: React.FC<{
  vm: BookOfBusinessViewModel;
}> = observer((props) => {
  const vm = props.vm;
    let env = Utils.getAppHostKey();
    const bookBaseUrl = `https://book-${env}.integrityconnect.com`.replace(
      "-prod",
      ""
    );
    // const bookBaseUrl = 'http://localhost:3003'; // enable only for local development
    const downlineAgencyIdParam = UserContext.downlineAgencyId
      ? `&downlineAgencyId=${UserContext.downlineAgencyId}`
      : '';
    let bookUrl =
    `${bookBaseUrl}/app?tenantName=${Utils.getBUName()}${downlineAgencyIdParam}&parentUrl=${window.location.origin}&hideTopNav=true`;
  return (
    <>
      {Utils.hasUserPermission(Permission.ViewProduction) ? (
        <div className="bob-container">
          <BookOfBusinessAuthRelay bookBaseUrl={bookBaseUrl} />
          <iframe src={`${bookUrl}`} id="bob-iframe" frameBorder="0" />
        </div>
      ) : (
        <Card>
          <IMASMessagesHandler response={Utils.errorMsg()} />
        </Card>
      )}
    </>
  );
});
